import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import { SearchResultBadge } from "@ext/serach/components/results/SearchResultBadge";
import type { SearchResultMarkItem } from "@ext/serach/Searcher";

export interface SearchResultFileHeaderItemProps {
	title: SearchResultMarkItem[];
	fileName?: SearchResultMarkItem[];
}

export const SearchResultFileHeaderItem = (props: SearchResultFileHeaderItemProps) => {
	const { title, fileName } = props;

	return (
		<>
			<div className="px-2.5 py-1.5 leading-none flex items-center gap-2.5">
				<SearchResultBadge
					icon="paperclip"
					text={
						<span>
							<SearchMarkedText marks={fileName ?? title} />
						</span>
					}
				/>
				{fileName && (
					<span className="leading-4 text-xs">
						{/* TODO: text around attachment */}
						<SearchMarkedText marks={title} />
					</span>
				)}
			</div>
		</>
	);
};
